import { render, staticRenderFns } from "./MicrosoftAdminOauthSettings.vue?vue&type=template&id=ded30584&scoped=true"
import script from "./MicrosoftAdminOauthSettings.vue?vue&type=script&lang=js"
export * from "./MicrosoftAdminOauthSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded30584",
  null
  
)

export default component.exports